(function() {
  window.cardService = {
    get() {
      return axios.get(`/api/card/get.php`);
    },
    getActive(data) {
      return axios.get('/api/card/active.php');
    },
    save(data) {
      return axios.post('/api/card/save.php', data);
    }
  }
})();